/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ChecklistActionPriority {
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    TERTIARY = 'TERTIARY',
}
